/**
 * Plan-gating helpers.
 *
 * excludedPlans field on a lesson indicates the highest plan tier that is
 * EXCLUDED from accessing the lesson:
 *
 *   "NONE"   → available to all plans
 *   "FREE"   → locked for Free users (requires Pro or higher)
 *   "PRO"    → locked for Free + Pro users (requires Family)
 *   "FAMILY" → locked for all plans
 */

const PLAN_TIER = { NONE: -1, FREE: 0, PRO: 1, PRO_PLUS: 2, FAMILY: 3 };

/**
 * Returns true if the lesson is locked for the given plan.
 *
 * @param {string} excludedPlans  - value from lesson.excludedPlans ("NONE"|"FREE"|"PRO"|"FAMILY")
 * @param {string} userPlan       - current effective plan ("free"|"pro"|"family")
 */
export function isLessonLocked(excludedPlans, userPlan) {
  const excluded = (excludedPlans || 'NONE').toUpperCase();
  if (excluded === 'NONE') return false;
  const tier = (userPlan || 'free').toUpperCase();
  return (PLAN_TIER[tier] ?? 0) <= (PLAN_TIER[excluded] ?? -1);
}

/**
 * Returns the minimum plan name needed to unlock the lesson.
 * e.g. excludedPlans="FREE" → "Pro"
 */
export function requiredPlanLabel(excludedPlans) {
  const excluded = (excludedPlans || 'NONE').toUpperCase();
  const labels = { FREE: 'Pro', PRO: 'Pro Plus', PRO_PLUS: 'Family', FAMILY: 'Family' };
  return labels[excluded] || null;
}
